import { $api } from "../../../../../services/request.config";
import { getJobHoursAction, setJobHoursLoadingAction } from "../getJobHours.action";

function formatJobHourLabel(value, name) {
    const formattedValue = value.toLocaleString("ru-RU", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return name ? `${formattedValue} ч. — ${name}` : `${formattedValue} ч.`;
}

export const getJobHoursThunkAction = () => async (dispatch) => {
    dispatch(setJobHoursLoadingAction(true));
    try {
        const response = await $api("v1/managers/requests/rvd/job-hours");
        const jobHours = (response.data || []).map((item) => ({
            id: item.value,
            name: formatJobHourLabel(item.value, item.name),
        }));
        dispatch(getJobHoursAction(jobHours));
    } catch (error) {
        dispatch(getJobHoursAction([]));
    } finally {
        dispatch(setJobHoursLoadingAction(false));
    }
};